import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useCustomerDBMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemCustomerInfo */
  const menuItemCustomerInfo = {
    id: "customerInfo",
    title: t("Modules.customer.customerInfo"),
    url: baseRouteMakerForSuperAdmin(routes.CUSTOMER_INFO),
  };
  tempMenuGroup.push(menuItemCustomerInfo);
  /* menuItemCustomerInfo */

  return tempMenuGroup;
};
